import { render, staticRenderFns } from "./96.vue?vue&type=template&id=0d6e99da&scoped=true&"
var script = {}
import style0 from "./96.vue?vue&type=style&index=0&id=0d6e99da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6e99da",
  null
  
)

export default component.exports